import React from "react";

import {
  GenericMultiFileTypeImporter,
  GenericMultiFileTypeImporterSection,
} from "components/Importer/GenericImporter";
import { Column } from "components/Layout";

import { CLEARING_SALE_PRE_SALE_CSV } from "constants/actionTypes";
import { IMPORTER_TYPES } from "constants/importer";

const clearingSalePreSaleCsvSections = [
  GenericMultiFileTypeImporterSection.VENDORS,
];

const ClearingSaleHelpTextComponent = () => (
  <Column>
    <ul>
      <li>
        The required fields are: Lot Number, Title, Quantity, Vendor Name.
      </li>
      <li>
        Sale Lots imported with matching lot numbers to existing ones will be
        updated with data from the CSV if Replace Data is unchecked.
      </li>
      <li>
        Sale Lots with a different Vendor Name or Vendor Commissions will be
        imported into separate consignments
      </li>
      <li>
        Vendor Notes will be combined and applied to the relevant Consignment.
        Vendor Notes are limited to 100 characters. Anything past the 100
        character limit will omitted.
      </li>
    </ul>
  </Column>
);

export function ClearingSalePreSaleCsvImporter() {
  return (
    <GenericMultiFileTypeImporter
      importName={IMPORTER_TYPES.CLEARING_SALE_PRE_SALE_CSV}
      fileTypes={["text/csv", "application/csv", ".csv"]}
      fileDescription="Sale Import CSV"
      type={CLEARING_SALE_PRE_SALE_CSV}
      sections={clearingSalePreSaleCsvSections}
      HelpTextComponent={ClearingSaleHelpTextComponent}
      acknowledgementFields={["Consignments", "Sale Lots"]}
      allowKeepData
    />
  );
}
